const isDevelopmentEnvironment = process.env.NODE_ENV === 'development';
const isNonDevelopmentEnvironment = !isDevelopmentEnvironment;
const isProductionEnvironment =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'production';
const isNonProductionEnvironment = !isProductionEnvironment;
const isTestEnvironment = process.env.NODE_ENV === 'test';
const isNonTestEnvironment = !isTestEnvironment;

export {
  isDevelopmentEnvironment,
  isNonDevelopmentEnvironment,
  isProductionEnvironment,
  isNonProductionEnvironment,
  isTestEnvironment,
  isNonTestEnvironment,
};
